import React,{useEffect,useState} from 'react'
import './Popular.css'
// import data_product from '../Assets/data'
import Item from '../Item/Item'
const Popular = () => {



 const[popularproducts,setPopularProducts]=useState([]);
  useEffect(()=>{
    fetch('https://sarathi-0cyh.onrender.com/popularinarts')
      .then((response) => {
        if (!response.ok) throw new Error(response.statusText);
        return response.json();
      })
      .then((data) => setPopularProducts(data))
      .catch((err) => {
        console.error('Failed to fetch popular products:', err);
        setPopularProducts([]);
      });
  },[])



  return (
    <div className='popular'>
      <h1>POPULAR ARTS</h1>
      <hr/>
      <div className="popular-item">
        {popularproducts.map((item,i)=>{
return <Item key={i} id={item.id} name={item.name} image={item.image} new_price={item.new_price} old_price={item.old_price}/>
        })}
      </div>
    </div>
  )
}

export default Popular
